import { render, staticRenderFns } from "./LocaleSelectorModal.vue?vue&type=template&id=66f84c68"
import script from "./LocaleSelectorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleSelectorModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LocaleSelectorModal.vue?vue&type=style&index=0&id=66f84c68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports